import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import { PrimaryButton } from '../Ui';
import CaptainMessage from './CaptainMessage';

import Video from './video';

import { getProjectById } from '../project-v2/projectsReducer';
import { getProject } from '../webAPI/MKSService';

import { cloneProjectTemplate } from '../webAPI/MKSService';

import T from '../common/translation';

export class CloneRoute extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isMessageReduced: false,
			cloning: false,
			maisonCloning: false,
			artisanCloning: false,
			salleCloning: false,
			ehpadCloning: false,
			ecoleCloning: false,
			entrepriseCloning: false,
			nouveauCloning: false,
			mairieCloning: false,
			crecheCloning: false,
			logementCloning: false,
			project: {},
			video: {}
		};

		this.toggleMessage = this.toggleMessage.bind(this);
		this.expandMessage = this.expandMessage.bind(this);
		this.reduceMessage = this.reduceMessage.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.redirectIfProjectStateIsNotinit = this.redirectIfProjectStateIsNotinit.bind(
			this
		);
	}

	componentDidMount() {
		const project = getProjectById(
			this.props.params.projectId,
			this.props.projects
		);

		if (project) {
			this.setState({ project }, this.redirectIfProjectStateIsNotinit);
		} else {
			getProject(this.props.params.projectId).then(
				() => {},
				result => {
					this.setState(
						{ project: result },
						this.redirectIfProjectStateIsNotinit
					);
				}
			);
		}

		// Setup video
		const video = new Video();
		this.setState({ video }, () => {
			this.state.video.startListen();
			this.state.video.moveVideo();
		});
	}

	componentWillUnmount() {
		this.state.video.stopListen();
	}

	render() {
		const { user } = this.props;
		const { project } = this.state;

		const captainMessageHeaderText = user.firstname
			? `Bienvenue à ${project.city} ${user.civility} ${user.firstname} ${user.lastname}`
			: `Bienvenue à ${project.city}`;

		return (
			<div className="video-content">
				<div className="video__wrapper js-video__wrapper">
					<video
						className="video js-video"
						autoPlay
						loop
						src="http://capitaine-cles.fr/media_mks/miniville2.mp4"
					/>
					<div className="js-video__controls video__controls">
						<div
							style={{
								position: 'absolute',
								top: '5%',
								left: '8%',
								opacity: this.state.cloning &&
									!this.state.maisonCloning
									? '0'
									: '0.9',
								transition: '1s'
							}}
						>
							<PrimaryButton
								rounded
								raised
								loading={this.state.maisonCloning}
								onClick={this.handleClick.bind(this, 'maison')}
							>

								Maison individuelle
							</PrimaryButton>
						</div>
						<div
							style={{
								position: 'absolute',
								top: '5%',
								left: '70%',
								opacity: this.state.cloning &&
									!this.state.artisanCloning
									? '0'
									: '0.9',
								transition: '1s'
							}}
						>
							<PrimaryButton
								raised
								rounded
								loading={this.state.artisanCloning}
								onClick={this.handleClick.bind(this, 'artisan')}
							>

								Maison artisan
							</PrimaryButton>
						</div>
						<div
							style={{
								position: 'absolute',
								top: '12%',
								left: '27%',
								opacity: this.state.cloning &&
									!this.state.salleCloning
									? '0'
									: '0.9',
								transition: '1s'
							}}
						>
							<PrimaryButton
								raised
								rounded
								loading={this.state.salleCloning}
								onClick={this.handleClick.bind(this, 'salle')}
							>

								Salle polyvalente
							</PrimaryButton>
						</div>
						<div
							style={{
								position: 'absolute',
								top: '10%',
								left: '57%',
								opacity: this.state.cloning &&
									!this.state.ehpadCloning
									? '0'
									: '0.9',
								transition: '1s'
							}}
						>
							<PrimaryButton
								raised
								rounded
								loading={this.state.ehpadCloning}
								onClick={this.handleClick.bind(this, 'ehpad')}
							>

								EHPAD
							</PrimaryButton>
						</div>
						<div
							style={{
								position: 'absolute',
								top: '27%',
								left: '12%',
								opacity: this.state.cloning &&
									!this.state.ecoleCloning
									? '0'
									: '0.9',
								transition: '1s'
							}}
						>
							<PrimaryButton
								raised
								rounded
								loading={this.state.ecoleCloning}
								onClick={this.handleClick.bind(this, 'ecole')}
							>

								Ecole
							</PrimaryButton>
						</div>
						<div
							style={{
								position: 'absolute',
								top: '25%',
								left: '80%',
								opacity: this.state.cloning &&
									!this.state.entrepriseCloning
									? '0'
									: '0.9',
								transition: '1s'
							}}
						>
							<PrimaryButton
								raised
								rounded
								loading={this.state.entrepriseCloning}
								onClick={this.handleClick.bind(
									this,
									'entreprise'
								)}
							>

								Entreprise
							</PrimaryButton>
						</div>
						<div
							style={{
								position: 'absolute',
								top: '50%',
								left: '13%',
								opacity: this.state.cloning &&
									!this.state.nouveauCloning
									? '0'
									: '0.9',
								transition: '1s'
							}}
						>
							<PrimaryButton
								raised
								rounded
								loading={this.state.nouveauCloning}
								onClick={this.handleClick.bind(this, null)}
							>

								Nouveau bâtiment
							</PrimaryButton>
						</div>
						<div
							style={{
								position: 'absolute',
								top: '43%',
								left: '41%',
								opacity: this.state.cloning &&
									!this.state.mairieCloning
									? '0'
									: '0.9',
								transition: '1s'
							}}
						>
							<PrimaryButton
								raised
								rounded
								loading={this.state.mairieCloning}
								onClick={this.handleClick.bind(this, 'mairie')}
							>

								Mairie
							</PrimaryButton>
						</div>
						<div
							style={{
								position: 'absolute',
								top: '45%',
								left: '72%',
								opacity: this.state.cloning &&
									!this.state.crecheCloning
									? '0'
									: '0.9',
								transition: '1s'
							}}
						>
							<PrimaryButton
								raised
								rounded
								loading={this.state.crecheCloning}
								onClick={this.handleClick.bind(this, 'creche')}
							>

								Crèche
							</PrimaryButton>
						</div>
						<div
							style={{
								position: 'absolute',
								top: '65%',
								left: '80%',
								opacity: this.state.cloning &&
									!this.state.logementCloning
									? '0'
									: '0.9',
								transition: '1s'
							}}
						>
							<PrimaryButton
								raised
								rounded
								loading={this.state.logementCloning}
								onClick={this.handleClick.bind(
									this,
									'logement'
								)}
							>

								Résidence
							</PrimaryButton>
						</div>
					</div>
				</div>
				<CaptainMessage
					headerText={captainMessageHeaderText}
					isReduced={this.state.isMessageReduced}
					onClick={this.toggleMessage}
				/>
			</div>
		);
	}

	toggleMessage() {
		if (this.state.isMessageReduced) {
			this.expandMessage();
		} else {
			this.reduceMessage();
		}
	}

	expandMessage() {
		this.setState({ isMessageReduced: false });
	}

	reduceMessage() {
		this.setState({ isMessageReduced: true });
	}

	handleClick(projectTemplateCode) {
		const { projectId } = this.props.params;
		if (projectTemplateCode) {
			this.setState({
				cloning: true,
				[projectTemplateCode + 'Cloning']: true
			});
		} else {
			this.setState({
				cloning: true,
				['nouveauCloning']: true
			});
		}
		cloneProjectTemplate(projectId, projectTemplateCode).then(
			() => {},
			result => {
				this.props.dispatch({
					type: 'CLONE_PROJECT_TEMPLATE_SUCCESS',
					projectId: projectId
				});
				browserHistory.push(
					'/app/project/' + encodeURIComponent(projectId) + '/plan'
				);
			}
		);
	}

	redirectIfProjectStateIsNotinit() {
		const { project } = this.state;
		const isInitialState = project.state === 'init';
		if (!isInitialState) {
			browserHistory.push('/app/project-v2');
		}
	}
}

function mapStateToProps(state) {
	return {
		user: state.user,
		projects: state.projects
	};
}

export default connect(mapStateToProps)(CloneRoute);



// WEBPACK FOOTER //
// ./src/js/clone-v2/CloneRoute.jsx